var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.325 14.259-.782-1.264L1 5c.18 1.002.986 3.222 2.766 4.088 1.78.866 7.114 3.808 9.559 5.17zm1.142 1.983-.842-1.263L2.563 9.088a3.4 3.4 0 0 0 2.405 3.126c1.924.626 7.134 2.946 9.499 4.029zM5.99 14.679l9.018 3.366h.721l-1.263-1.142-10.701-4.329c0 .28.12.938.6 1.323.482.385 1.283.681 1.624.781zm9.86 3.066-1.203-2.526.842-.841-.181-.663.54-1.142.66.902-.66.902v1.14l1.202-1.141v1.442l-1.202 1.924zm-1.924 6.733.721.72c.28-1.222.842-3.751.842-4.088v4.57l.36.961.66-.962v-2.163l.542-.54.36 2.223.722-1.262-1.623-5.712v4.209l-1.02-4.208-1.564 6.252zm5.53-11.484-.78 1.262c2.444-1.362 7.779-4.304 9.559-5.17C30.015 8.222 30.82 6.002 31 5l-11.543 7.996zm-1.081 1.984-.842 1.263c2.365-1.083 7.575-3.403 9.5-4.029a3.4 3.4 0 0 0 2.404-3.126L18.375 14.98zm-1.383 3.066 9.018-3.367c.34-.1 1.142-.397 1.623-.782.481-.385.602-1.042.602-1.323l-10.702 4.329-1.263 1.142h.722z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhb);
export default __webpack_public_path__ + "static/media/PHB.b41205c9d83eb9d66c0da6ff27b3fe64.svg";
export { ForwardRef as ReactComponent };